import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { SfAccount } from '../../api/types/sfRedirect.types';

import { getSfAccount } from '../../api/get-sf-account/getSfAccount';

export function useSfAccount(
  sfAccountId: string
): UseQueryResult<SfAccount, Error> {
  return useQuery<SfAccount, Error>({
    queryKey: ['sf-account', sfAccountId],
    queryFn: (): Promise<SfAccount> => getSfAccount(sfAccountId),
    enabled: !!sfAccountId,
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
